<template>
  <div class="ui grid">
    <div class="row">
      <h3 class="ui huge header">Licenses</h3>
    </div>
    <div class="ui divider"></div>
    <div class="row">
      <sui-form>
        <sui-form-field>
          <label>Status</label>
          <sui-dropdown selection name="licenseStatusSelection" :options="licenseStatusOptions"
            v-model="licenseStatusSelection" />
        </sui-form-field>
        <!-- <sui-button type="button" positive v-on:click="submit">
          Display licenses
        </sui-button> -->
      </sui-form>
    </div>
    <div class="row" v-if="licenseStatusSelection === 'expiring'">
      <span>These {{ licenses.length }} licenses are about to expire within the next 4 weeks with no new (final) license
        created.</span>
    </div>
    <div class="row" v-if="licenseStatusSelection === 'expired'">
      <span>These {{ licenses.length }} licenses have expired with no new (final) license created.</span>
    </div>
    <div class="row" v-if="licenseStatusSelection === 'active'">
      <span>These {{ licenses.length }} licenses are active.</span>
    </div>
    <div class="row">
      <licenses-table v-bind:licenses="licenses" v-bind:actions="licensesActions" v-on:rowAction="rowAction"
        show-school="true" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LicensesTable from '@/components/licenses/LicensesTable';
import moment from 'moment';

export default {
  name: 'LicensesSelection',
  components: { LicensesTable },
  computed: {
    totalBalance() {
      return this.licenses.reduce(
        // eslint-disable-next-line no-return-assign
        (total, license) => (total += license.balance),
        0,
      );
    },
    totalVat() {
      return this.licenses.reduce(
        // eslint-disable-next-line no-return-assign
        (total, license) => (total += license.vat),
        0,
      );
    },
    overdueBalance() {
      return this.licenses
        .filter(
          // eslint-disable-next-line arrow-parens
          (license) =>
            moment(license.dueAt).diff(this.currentDate, 'days') <= 0,
        )
        .reduce(
          // eslint-disable-next-line no-return-assign
          (total, license) => (total += license.balance),
          0,
        );
    },
    ...mapGetters({
      licenses: 'licenses',
    }),
  },
  data() {
    return {
      licensesActions: ['View'],
      licenseStatusSelection: 'active',
      licenseStatusOptions: [
        { text: 'Active', value: 'active' },
        { text: 'Expiring', value: 'expiring' },
        { text: 'Expired', value: 'expired' },
      ],

    };
  },
  methods: {
    submit() {
      this.retrieveLicenses();
    },
    retrieveLicenses() {
      switch (this.licenseStatusSelection) {
        case 'active':
          this.$store.dispatch('getActiveLicenses');
          break;
        case 'expiring':
          this.$store.dispatch('getExpiringLicenses');
          break;
        case 'expired':
          this.$store.dispatch('getExpiredLicenses');
          break;
        default:
          this.$store.dispatch('getActiveLicenses');
      }
    },
    formatAsPrice(value) {
      const formattedNumber = value.toFixed(2);
      const [integerPart, decimalPart] = formattedNumber.split('.');

      const formattedInteger = parseInt(integerPart, 10).toLocaleString(
        undefined,
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        },
      );

      return `€${formattedInteger}${decimalPart ? '.' : ''}${decimalPart || ''
        }`;
    },
    rowAction(action) {
      if (action.action === 'View') {
        // eslint-disable-next-line arrow-parens
        const license = this.licenses.find((l) => l.id === action.id);
        this.$router.push(`/school/details/${license.schoolId}?return=expiring`);
      }
    },
  },
  watch: {
    licenseStatusSelection(newValue) {
      this.retrieveLicenses();
    }
  },
  created() {
    this.retrieveLicenses();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/licenses/LicensesSelection.vue